import { Controller } from "@hotwired/stimulus"

// Generic nested-row builder for the onboarding wizard (products + tiers steps).
// "Add" clones the <template> row, substituting a fresh index for __INDEX__ so
// field names stay unique; "Remove" deletes the row's <li>. No server round-trip.
export default class extends Controller {
  static targets = ["list", "template"]
  static values = { index: Number } // seed with the initial row count

  add() {
    const html = this.templateTarget.innerHTML.replaceAll("__INDEX__", this.indexValue++)
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.currentTarget.closest("li").remove()
  }
}
